import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TemplateEntityVariableEnum } from '@zaoblako/shared/common/enums/template.entity.variable.enum';
import { InputTextComponent } from '@zaoblako/web/shared/dumbs/input-text/input-text.component';
import { ButtonModule } from 'primeng/button';
import { ListboxModule } from 'primeng/listbox';

@Component({
  standalone: true,
  selector: 'crm-template-subject-input',
  templateUrl: './template-subject-input.component.html',
  imports: [CommonModule, InputTextComponent, ButtonModule, ListboxModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateSubjectInputComponent {
  @Input() public subject: string;
  @Output() public subjectChange = new EventEmitter<string>();

  @Input() public isError: boolean;

  public showTemplateOptions = false;
  public templateOptions = Object.values(TemplateEntityVariableEnum).map((option) => '{{' + option + '}}');

  public onTemplateOptionSelect(option: string, input: HTMLElement) {
    this.subject = this.subject ? this.subject + option : option;
    this.subjectChange.emit(this.subject);
    this.showTemplateOptions = false;
    input.focus();
  }
}
